import * as Sentry from '@sentry/react';
import {
  Box,
  VStack,
  Alert,
  AlertIcon,
  AlertTitle,
  AlertDescription,
} from '@chakra-ui/react';
import Header from 'components/Header';
import AppRoutes from 'config/AppRoutes';
import tagging from 'features/tagging/tagging';
import { useEffect } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import Button from 'ui/molecules/Button';
import useAnswerSanityCheck from 'utils/hooks/useAnswerSanityCheck';
import { LegalFooter } from '../../components/LegalFooter/LegalFooter';

type Props = {
  children?: React.ReactNode;
};

const ErrorFallback = ({
  error,
  resetError,
}: {
  error: Error;
  resetError: () => void;
}) => (
  <Alert
    status="error"
    flexDirection="column"
    alignItems="center"
    justifyContent="center"
  >
    <AlertIcon />
    <AlertTitle>Oops something went wrong</AlertTitle>
    <AlertDescription>
      <pre>{error?.message as string}</pre>
    </AlertDescription>
    <Button onClick={resetError}>Reload page</Button>
  </Alert>
);

const BaseLayout = ({ children }: Props) => {
  const navigate = useNavigate();
  const location = useLocation();
  const isFlowChoiceRoute = window.location.hash.includes(
    AppRoutes.FLOW_CHOICE
  );
  const isBusinessChoiceRoute = window.location.hash.includes(
    AppRoutes.BUSINESS_CHOICE
  );
  useAnswerSanityCheck();

  // callback for tagging
  useEffect(() => {
    // execute on location change
    tagging.tagUpdateEvent(location.pathname);
  }, [location]);

  return (
    <VStack
      height="100vh"
      display="flex"
      width="full"
      // width={{
      //   base: '600px',
      //   md: '50%',
      // }}
      overflowX="hidden"
      background={
        isFlowChoiceRoute || isBusinessChoiceRoute
          ? 'reno.grey500'
          : 'transparent'
      }
    >
      <Sentry.ErrorBoundary
        fallback={ErrorFallback}
        onReset={() => {
          navigate('/');
        }}
      >
        <Header />
        <Box display="flex" flex="auto" width="full" justifyContent="center">
          {children}
        </Box>
        {/* <Footer /> */}
        <LegalFooter />
      </Sentry.ErrorBoundary>
    </VStack>
  );
};

export default BaseLayout;
